import * as React from "react";
import { Col } from 'reactstrap';
import ChartLoader from "src/share/components/ChartLoader/ChartLoader";
import { ChartByDate } from "src/share/components/Chart/ChartByDate";
import { YearLoader } from "src/share/components/ChartLoader/YearLoader";
import { GAInsightsChart } from "./GAInsightsChart";
import { GAPageViews } from "src/share/components/GoogleAnalitycs/GAPageViews";
import { useDaysAgo } from "../hooks/useDaysAgo";
import { useAlertStatistics } from "../hooks/useAlertStatistics";

interface IAlertInsightsStatsProps {
  alertId: string;
  pagePath: string;
  views: {
    query: {
      ids: string
    }
  }
}

const AlertInsightsStats = ({ alertId, pagePath, views }: IAlertInsightsStatsProps) => {
  const [daysAgo, error] = useDaysAgo(alertId);
  const [alertStatistics] = useAlertStatistics(alertId, views, daysAgo, pagePath, error);
  return (
    <>
      <div className="margin-big-card half-cards row">
        <Col className="col-12 no-padding-left">
          <Col className="col-12 white-background">
            <h5>Insights comparisson</h5>
            <ChartLoader chart={GAInsightsChart} loader={YearLoader} data={alertStatistics.statistics} loading={alertStatistics.loading} />
          </Col>
        </Col>
      </div>
      <div className="margin-big-card half-cards row">
        <Col className="col-12 no-padding-left">
          <Col className="col-12 white-background">
            <h5>Ad impressions</h5>
            <ChartLoader
              chart={ChartByDate}
              loader={YearLoader}
              data={alertStatistics.impressions}
              dataKey={'impressions'}
              dateKey={'day'}
              loading={alertStatistics.loading} />
          </Col>
        </Col>
      </div>
      <div className="margin-big-card half-cards row">
        <Col className="col-12 no-padding-left">
          <GAPageViews pagePath={pagePath} daysAgo={daysAgo || 0} pageViews={alertStatistics.pageViews} />
        </Col>
      </div>
    </>
  )
}

export default AlertInsightsStats;
